var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.03101L6.3273 8.06201L12.655 4.03101L6.3278 0L0 4.03101Z",
    fill: "#535F79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.645 4.03101L18.9723 8.06201L25.2997 4.03101L18.9725 0L12.645 4.03101Z",
    fill: "#535F79"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.0367L6.3274 16.0677L12.6548 12.0367L6.3274 8.00562L0 12.0367Z",
    fill: "#535F79"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9726 8.00562L12.645 12.0367L18.9724 16.0677L25.2998 12.0367L18.9726 8.00562Z",
    fill: "#535F79"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36816 17.4034L12.6956 21.4345L19.023 17.4034L12.6956 13.3728L6.36816 17.4034Z",
    fill: "#535F79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropbox);
export default __webpack_public_path__ + "static/media/Dropbox.63426ac8a3cff5bdd718ec4fec886579.svg";
export { ForwardRef as ReactComponent };